<header>
    <app-header></app-header>
</header>

<main>
    <div class="body">
        <router-outlet></router-outlet>
    </div>
</main>

<footer></footer>

<p-toast
    id="error-messages-anchor"
    position="top-center"
    [key]="toasterPositions.TOP_CENTER"
    [preventOpenDuplicates]="true">
</p-toast>
<p-toast
    id="warning-success-messages-anchor"
    position="bottom-right"
    [key]="toasterPositions.BOTTOM_RIGHT"
    [preventOpenDuplicates]="true">
</p-toast>
